import _, { sumBy, xor } from "lodash";
import { isAmount } from "../datapoints-api/helper";
import { generateTooltipItems } from "../datapoints-api/visitors/custom/tooltips";
import { ShownValuesTypes } from "components/widgets/chart/base/chart-settings/types";
import { language } from "language/default";
const labels = language.en.skeleton.settingsMenu.shownValues;
const createOthersCompositeMeasure = (custom, otherPoints) => {
    const othersComposeMesure = { ...custom.compositeMeasure };
    if (othersComposeMesure.measures) {
        if (isAmount(othersComposeMesure.measures.VALUE)) {
            othersComposeMesure.measures.VALUE.amount = sumBy(otherPoints, (p) => p.y ?? 0);
        }
        const totalPercentage = sumBy(otherPoints, (p) => p.custom?.compositeMeasure?.measures?.TotalPercentage ?? 0);
        if (totalPercentage) {
            othersComposeMesure.measures.TotalPercentage = totalPercentage;
        }
        othersComposeMesure.dimension = labels.others;
    }
    return othersComposeMesure;
};
const createOthersMetadata = (custom) => ({ ...custom.metadata });
const addOtherPointFiltred = (filteredPoints, othersPoint, filter) => {
    if (filter === ShownValuesTypes.Bottom) {
        filteredPoints.unshift(othersPoint);
    }
    else {
        filteredPoints.push(othersPoint);
    }
};
const addOtherPoints = (filteredPoints, points, setting, valueSelector) => {
    const otherPoints = xor(filteredPoints, points);
    if (otherPoints && otherPoints.length) {
        // Use first point as an base
        const [firstPoint] = otherPoints;
        const othersPoint = {
            ..._.cloneDeep(firstPoint),
            className: "highcharts-color-grey",
            name: `${labels.others} (${otherPoints.length})`,
            y: sumBy(otherPoints, valueSelector)
        };
        // Overwrite custom part and tooltip
        if (othersPoint.custom) {
            const othersComposeMesure = createOthersCompositeMeasure(othersPoint.custom, otherPoints), othersMetadata = createOthersMetadata(othersPoint.custom);
            othersPoint.custom = { tooltip: generateTooltipItems(othersComposeMesure, othersMetadata) };
        }
        addOtherPointFiltred(filteredPoints, othersPoint, setting.filter);
    }
    return filteredPoints;
};
const filterByPercentageValue = (data, quantity, valueSelector) => {
    const sum = sumBy(data, valueSelector);
    return data.filter((obj) => valueSelector(obj) * 100 / sum > quantity);
};
export const filterShownValues = (data, setting, valueSelector, addOther) => {
    data.sort((a, b) => valueSelector(b) - valueSelector(a));
    let returnArray = [...data];
    if (setting.filter === ShownValuesTypes.Top && setting.quantity) {
        returnArray = returnArray.slice(0, setting.quantity);
    }
    if (setting.filter === ShownValuesTypes.Bottom && setting.quantity) {
        returnArray = returnArray.slice(Math.max(returnArray.length - setting.quantity, 0));
    }
    if (setting.filter === ShownValuesTypes.BiggerThan && setting.quantity) {
        returnArray = filterByPercentageValue(returnArray, setting.quantity, valueSelector);
    }
    return addOther && setting.filter !== ShownValuesTypes.All ? addOtherPoints(returnArray, data, setting, valueSelector) : returnArray;
};
